import type { ComponentType } from 'react'

import { usePartner } from '@/blocks/HeroWithCta/hocs/usePartner'
import { useBuilderState } from '@/hooks/useBuilderState'

import type { HeroWithCtaProps } from '../HeroWithCta'

export function withDebtsPartnerDiscount(Component: ComponentType<HeroWithCtaProps>) {
  return function HeroWithDebtsPartnerDiscount(propsFromBuilder: HeroWithCtaProps) {
    const { path } = useBuilderState()
    const currentPartner = usePartner({ path })

    if (!path) return <Component {...propsFromBuilder} />

    const isPartnerPage = path.includes('/limpa-nome-online/parceiros/')
    const isPartnerListPage = path.endsWith('/limpa-nome-online/parceiros/')

    if (!(isPartnerPage && !isPartnerListPage)) {
      return <Component {...propsFromBuilder} />
    }

    const title = currentPartner
      ? {
          text: `Negociação de dívida ${currentPartner.name} com até ${currentPartner.discount}% de desconto`,
          tag: 'h1',
        }
      : propsFromBuilder.hero.title

    return (
      <Component
        {...propsFromBuilder}
        hero={{
          title,
          subtitle: propsFromBuilder.hero.subtitle,
          colorModifier: propsFromBuilder.hero.colorModifier,
        }}
      />
    )
  }
}
